import React from 'react';
import PropTypes from 'prop-types';
import classes from './ReusableContentA.module.scss';

const ReusableContentA = (props) => {
  const { content } = props;

  return (
    <div className={classes.container}>
      {content && <div
        className={classes.content}
        dangerouslySetInnerHTML={{ __html: content }}
      />}
    </div>
  );
};

ReusableContentA.propTypes = {
  content: PropTypes.string,
};

export default ReusableContentA;
